import o from "./ghl-ui.es402.js";
var r = 1, n = 4;
function L(e) {
  return o(e, r | n);
}
export {
  L as default
};
